import axios from "axios";
import { URL_BASE } from "../config/url-server";

const clientId = localStorage.getItem("client")
const accessToken = localStorage.getItem("token")



export const unproductivePalms = async (startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "map/unproductive-palms",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};




export const healthMovementMap = async (startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "map/health-movement-map",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const mapFirstApplication = async (startDate, endDate,farmId,sectionId,lotId,userId) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,userId };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "map/map-first-application",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};







export default {
  healthMovementMap,
  unproductivePalms,
  mapFirstApplication
};
